<template>
  <div class="right_top">
      <div class="title_1" v-if="!ContentStatus">{{list[newData].title}}</div>
      <div class="title_1 title_lang" v-if="ContentStatus">{{remakTitle}}</div>
       <div class="title_2" v-if="!ContentStatus">{{list[newData].small_title}}</div>
        <div class="title_3" v-if="title!='联系我们'"><span style="color:#393939">首页/{{title}}/</span>{{list[newData].hasTitle}}</div>
        <div class="title_3" v-if="title=='联系我们'"><span style="color:#393939">首页/</span>{{list[newData].hasTitle}}</div>
  </div>
</template>
  <script>
export default {
  name: "youfuwu",
  data() {
    return {};
  },
  methods: {},
  mounted: function() {
   
  },
  components: {},
  props: {
    list: Array,
    title: String,
     newData:Number,
     ContentStatus:Boolean,
     remakTitle:String
  },
};
</script>
<style scoped="scoped">
.right_top{
    width: 100%;
    height: 0.5375rem;
    border-bottom: 1px solid #40684C;
    display: flex;
    align-items: center;
    position: relative;

}
.title_1{
  /* width: 60%; */
font-size: 0.35rem;
font-family: PingFang SC;
font-weight: 500;
color: #40684B;
margin-right: 0.375rem;

}
.title_2{
    
font-size: 0.35rem;
font-family: PingFang SC;
font-weight: 500;
color: #CCCCCC;

}
.title_3{
position: absolute;
font-size: 0.25rem;
font-family: PingFang SC;
font-weight: 400;
color: #40684B;
right: 0;

}
.title_lang{
  width: 60%;
  overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap;
}
</style>